/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useState, useEffect
} from 'react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { MLAddressVerificationService } from 'gw-capability-quoteandbind';
import { MLNotificationBlockUtil, MLPupLineValidatorUtil } from 'ml-portals-util-react';
import { FormModalPopover, platformMessages as commonMessages } from 'ml-components-platform-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { ServiceManager } from '@jutro/legacy/services';
import { MLLocationUtil } from 'ml-portals-util-js';
import appConfig from 'app-config';

import PropTypes from 'prop-types';
import _ from 'lodash';

import messages from './LocationTableActionComponent.messages';
import metadata from './LocationTableActionComponent.metadata.json5';
import styles from './LocationTableActionComponent.scss';

import LocationPopupComponent from '../LocationPopupComponent/LocationPopupComponent';

const ACTION_ADD_LOCATION = 'addLocation';

function LocationTableActionComponent(props) {
    const {
        submissionVM,
        hideAdd,
        onEdit,
        onRemove,
        onCancel,
        showLocMayNotBeRemovedAlert,
        updateWizardData,
        showAnimalExclusionWarningMessage,
        syncExposure,
        getUnderlyingPolicies,
        quotePageAddFunction,
        quotePageEditRemoveFunction,
        createUnderlyingPolicy,
        validateAllLocations,
        policyAddress,
        validateULPolicy,
        setIsStepActionModalOpen,
        stepActionData,
        setDisableNextButton
    } = props;

    const {
        showProgressDialog
    } = MLModalService();
    const {
        clearAlerts,
        clearSuccessAlerts,
        clearBlockAlerts,
        addErrorAlert,
        addSuccessAlert,
        clearManyBlockAlerts
    } = MLNotificationBlockUtil()
    const MLPUPLineValidatorUtilInstance = MLPupLineValidatorUtil();

    const isGPA = appConfig.portalCode === 'GPA';
    const localeService = ServiceManager.getService('locale-service');
    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const { locations } = pupModel.coverables;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    let locationErrors = false;
    const [isInEditMode, updateIsInEditMode] = useState(false);
    const [nextID, updateNextID] = useState(0);
    const [locationToEdit, setLocationToEdit] = useState();
    const productCode = _.get(submissionVM, 'baseData.productCode.value');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [exposureVM, setExposureVM] = useState();
    const [isEdit, setIsEdit] = useState();

    const locationTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('PUPLocationType_PUE');

    const formatLocationString = (location) => (location.address.addressLine1 ? `${location.address.addressLine1} ${location.address.city} ${location.address.state} ${location.address.postalCode}` : 'undefined');

    const addAdditionAlert = (added) => {
        clearSuccessAlerts();
        addSuccessAlert({...messages.itemHasBeenAdded, args: { item: formatLocationString(added) }}, 'addingLocationExposure');
    };

    const createErrorMessage = (contentOfError) => {
        const alertName = `needsAttention${contentOfError}`;
        addErrorAlert({...messages.itemNeedsAttention, args: { item: contentOfError }}, alertName)
    };

    const undoLocationRemoval = (location) => {
        locations.value.push(location);
        if(validateULPolicy){
            validateULPolicy();
        }
        clearAlerts();
    };

    const addRemovalAlert = (location) => {
        clearSuccessAlerts();
        addSuccessAlert({...messages.itemHasBeenRemoved, args: { item: formatLocationString(location) }}, 'removeLocationExposure', () => undoLocationRemoval(location))
    };

    const addLocMayNotBeRemovedAlert = () => {
        clearSuccessAlerts();
        clearManyBlockAlerts(['locationCannotBeRemovedExposure']);
        addErrorAlert(messages.itemMayNotBeRemoved, 'locationCannotBeRemovedExposure');
    };

    const resetEditingLocation = () => {
        locations.value.forEach((loc) => {
            loc.isEditing = false;
        });
    };

    const getAnswerForTrampolineQuestion = (questions) => {
        let trampolineQuestionType = false;
        if (questions) {
            questions.forEach((question) => {
                if (question.answers && question.answers.value.PUPPolicyLocationTrampolineNet_ML === null && question.answers.value.PUPPolicyLocationTrampoline_ML === 'true') {
                    trampolineQuestionType = true;
                }
            });
        }
        return trampolineQuestionType;
    };

    const findLocationWithAnimalQuestion = (location) => {
        if (location) {
            return location.locationQuestionSet.questionSets.children.some((locationsQS) => {
                return !locationsQS.aspects.valid;
            });
        }
    };

    const getAnswerForAnimalQuestion = (questions, location) => {
        let isAnimalQuestionValid = false;
        if (questions) {
            questions.forEach((question) => {
                // check if "Do you have any animals?" question is true
                if (question.answers && question.answers.value.PUPPolicyLocationHasAnimals_ML === 'true') {
                    isAnimalQuestionValid = findLocationWithAnimalQuestion(location);
                }
            });
        }
        return isAnimalQuestionValid;
    };

    const checkForError = (potentialLocations) => {
        potentialLocations.forEach((location) => {
            if (location) {
                const trampolineQuestionType = getAnswerForTrampolineQuestion(location.locationQuestionSet.questionSets);
                const isAnimalQuestionValid = getAnswerForAnimalQuestion(location.locationQuestionSet.questionSets, location);
                if (isAnimalQuestionValid || trampolineQuestionType) {
                    location.error = true;
                    locationErrors = true;
                } else {
                    location.error = false;
                    locationErrors = false;
                }
            }
        });
    };

    const addLocation = () => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Location`);
        const newLocation = {
            tempID: nextID + 1
        };
        updateNextID(nextID+1);
        const locationVM = viewModelService.create(newLocation, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PupLocationDTOML');
        locationVM.isModernProduct.value = submissionVM.value.isModernProduct_Ext;
        locationVM.isDwellingUsageRequired_ML = true;
        locationVM.isDwellingOccupancyRequired_ML = true;
        locationVM.address.value = {};
        if (_.isUndefined(locationVM.address.country.value)) {
            locationVM.address.country.value = localeService.getDefaultCountryCode();
        }
        locationVM.isFromPortal = true;
        resetEditingLocation();
        locationVM.value.isEditing = true;
        locations.value.push(locationVM.value);
        updateIsInEditMode(false);
        return locationVM;
    };

    const editLocation = (index) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Edit Location`);
        const locationVM = locations.children[index.index];
        locationVM.isModernProduct.value = submissionVM.value.isModernProduct_Ext;
        setLocationToEdit(_.clone(locationVM.value));

        resetEditingLocation();
        locationVM.value.isEditing = true;
        locationVM.isDwellingUsageRequired_ML = true;
        locationVM.isDwellingOccupancyRequired_ML = true;

        updateIsInEditMode(true);
        return locationVM;
    };

    const saveLocationEdit = (location) => {
        let currentIndex = -1;
        if (location.publicID.value) {
            currentIndex = locations.children.findIndex((loc) => { return loc.publicID.value === location.publicID.value; });
        } else {
            currentIndex = locations.children.findIndex((loc) => { return loc.tempID.value === location.tempID.value; });
        }
        if (currentIndex !== -1) {
            locations.value[currentIndex] = location.value;
        }
    };

    const validateBeforeSave = (location) => {
        if(!policyAddress){
            return {showPrimaryLocationError: false}
        }
        const primaryLocationErrorMessage = MLPUPLineValidatorUtilInstance.validatePrimaryLocation(location, locations, policyAddress);
        return {
            primaryLocationErrorMessage,
            showPrimaryLocationError: !!primaryLocationErrorMessage
        }
    }

    const onSaveLocation = async (location) => {
        if (location.ulPolicyFixID.value === 'new') {
            location.ulPolicyFixID = undefined;
        }
        if (location.aspects.valid && location.aspects.subtreeValid) {

            if(validateAllLocations){
                validateAllLocations();
            }
            MLLocationUtil.resetWhenLocationTypeVacantLand(location);
            const validation = validateBeforeSave(location);
            if(validation.showPrimaryLocationError){
                return translator(validation.primaryLocationErrorMessage);
            }

            try {
                await MLAddressVerificationService.validateAddress(viewModelService, location.address, productCode);
            } catch (err) {
                return false;
            }
            if (isInEditMode) {
                clearSuccessAlerts();
                saveLocationEdit(location);
            } else {
                addAdditionAlert(location.value);
            }
            checkForError(locations.children);
            const showError = (location.locationQuestionSet.shouldDispalyAnimalExclusionWarning_ML) ? location.locationQuestionSet.shouldDispalyAnimalExclusionWarning_ML.value : false;
            showAnimalExclusionWarningMessage(showError);
            clearBlockAlerts('needsAttentionLocations');
            if (locationErrors) {
                createErrorMessage('Locations');
            }
            updateWizardData(submissionVM);
            setIsModalOpen(false);
            if(validateULPolicy){
                validateULPolicy();
            }
            return true;
        }
        return false;
    };

    const createExposureModal = (_exposureVM, _isEdit) => {
        setIsModalOpen(true);
        setExposureVM(_exposureVM);
        setIsEdit(_isEdit);
        updateIsInEditMode(_isEdit);
    }

    const getModal = () => {
        const addLocationModalTitle = isEdit ? `${translator(messages.EditLocationPopupHeader)}` : `${translator(messages.AddLocationPopupHeader)}`;
        const addLocationModalSubtitle = translator(messages.LocationModalSubtitle);

        const onRejectModal = () => {
            const index = locations.value.indexOf(exposureVM.value);
            if (index !== -1) {
                if (isInEditMode) {
                    locations.value[index] = locationToEdit;
                } else {
                    locations.value.splice(index, 1);
                }
                updateWizardData(submissionVM);
                setIsModalOpen(false);
                if(validateAllLocations){
                    validateAllLocations();
                }
                if(validateULPolicy){
                    validateULPolicy();
                }
            }
        };

        const componentProps = {
            title: addLocationModalTitle,
            subtitle: addLocationModalSubtitle,
            actionBtnLabel: commonMessages.mlContinue,
            onAsyncSaveAction: onSaveLocation,
            CustomComponent: LocationPopupComponent,
            showBannerMessage: true,
            overrideProps: {
                pupModel,
                locationVM: exposureVM,
                syncExposure,
                getUnderlyingPolicies,
                quoteID: submissionVM.quoteID.value,
                showProgressDialog,
                createUnderlyingPolicy,
                showAnimalExclusionWarningMessage,
                validateBeforeSave,
                submissionVM
            },
            isOpen: isModalOpen,
            onReject: onRejectModal,
            onResolve: () => { setIsModalOpen(false)}
        };

        return (<FormModalPopover {...componentProps} />)
    };


    const onAddLocation = () => {
        const locationVM = addLocation();
        createExposureModal(locationVM, false);
        setDisableNextButton(false);
    };

    const onEditLocation = (index) => {
        const locationVM = editLocation(index);
        createExposureModal(locationVM, true);
        setDisableNextButton(false);
    };

    const onRemoveLocation = (index) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove Excluded Location`);
        const locationToRemove = locations.value[index.index];
        locations.value.splice(index.index, 1);
        addRemovalAlert(locationToRemove);
        updateWizardData(submissionVM);
        setDisableNextButton(false);
    };

    // Redirect Function
    const handleStepAction = (redirectAction) => {
        if (!_.isEmpty(redirectAction)) {
            if (redirectAction.action === ACTION_ADD_LOCATION) {
                onAddLocation();
                setIsStepActionModalOpen(true);
            }
        }
    };

    useEffect(() => {
        if (!_.isEmpty(stepActionData)) {
            handleStepAction(stepActionData);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // End Redirect Functions

    const editLocationClicked = (index) => {
        if (quotePageEditRemoveFunction) return quotePageEditRemoveFunction();
        if (onEdit) return onEdit(locations.children[index.index].value, onCancel);
        return onEditLocation(index);
    };

    const removeLocationClicked = (index) => {
        const item = locations.children[index.index].value;
        if (!item.isFromPortal) {
            if (showLocMayNotBeRemovedAlert) {
                addLocMayNotBeRemovedAlert();
            }
        } else if (quotePageEditRemoveFunction) {
            return quotePageEditRemoveFunction();
        } else if (onRemove) {
            return onRemove(item, onCancel);
        } else {
            return onRemoveLocation(index);
        }
    };

    const generateLocationOverrides = () => {
        if (locations.value) {
            const getTypeKeyDescription = (typeKeyName) => {
                return translator({
                    id: typeKeyName,
                    defaultMessage: typeKeyName
                });
            };

            const getYesNoAnswer = (val) => (val ? translator(messages.yes) : translator(messages.no));

            const overrides = locations.value.map((location, index) => {
                return {
                    [`typeCell${index}`]: {
                        content: location.locationType !== undefined ? getTypeKeyDescription(locationTypeList.getCode(location.locationType).name) : ''
                    },
                    [`typeCellStatus${index}`]: {
                        visible: location.error === true
                    },
                    [`cityCell${index}`]: {
                        content: _.get(location, 'address.city', '')
                    },
                    [`stateCell${index}`]: {
                        content: _.get(location, 'address.state', '')
                    },
                    [`addressCell${index}`]: {
                        content: _.get(location, 'address.addressLine1', '')
                    },
                    [`excludedCell${index}`]: {
                        content: getYesNoAnswer(location.isExcluded)
                    },
                    [`editActionCell${index}`]: {
                        content: 'Edit',
                        'aria-labelledby': `typeCellContent${index} cityCellContent${index} stateCellContent${index} addressCellContent${index} excludedCellContent${index}`
                    },
                    [`removeActionCell${index}`]: {
                        content: 'Remove',
                        'aria-labelledby': `typeCellContent${index} cityCellContent${index} stateCellContent${index} addressCellContent${index} excludedCellContent${index}`
                    },
                };
            });
            return Object.assign({}, ...overrides);
        }
        return {};
    };

    const overrideProps = {
        locationHeader: {
            className: isGPA ? 'vertical-spacing-20 section-header' : 'vertical-spacing-20 amp-section-header',
            content: translator(messages.LocationHeader)
        },
        LocationTable: {
            visible: locations.length > 0
        },
        locationsIterable: {
            data: locations.value
        },
        headerRow:{
            visible: locations.length>0
        },
        mlTableActionsDefaultButton: {
            visible: !hideAdd,
            className: 'display-inline-block margin-top-20',
            type: isGPA ? 'outlined' : 'filled',
            content: translator(messages.AddLocation),
            onClick: quotePageAddFunction || onAddLocation
        },
        locationParagraph:{
            visible: locations.length <= 0,
            content:translator(messages.LocationParagraph)
        },
        ...generateLocationOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onEditLocation: editLocationClicked,
            onAddLocation: quotePageAddFunction || onAddLocation,
            onRemoveLocation: removeLocationClicked,
            onSaveLocation,
            getUnderlyingPolicies
        }
    };

    return (
        <>
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={styles}
                onModelChange={updateWizardData}
            />
            {isModalOpen && getModal()}
        </>
    );
}

LocationTableActionComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    hideAdd: PropTypes.bool,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    onCancel: PropTypes.func,
    showLocMayNotBeRemovedAlert: PropTypes.bool,
    updateWizardData: PropTypes.func.isRequired,
    showAnimalExclusionWarningMessage: PropTypes.func.isRequired,
    onValidate: PropTypes.func.isRequired,
    getUnderlyingPolicies: PropTypes.func.isRequired,
    syncExposure: PropTypes.func.isRequired,
    quotePageAddFunction: PropTypes.func,
    quotePageEditRemoveFunction: PropTypes.func
};

LocationTableActionComponent.defaultProps = {
    showLocMayNotBeRemovedAlert: true,
    hideAdd: false
};

export default LocationTableActionComponent;
